<ng-container>
  <div class="external-id">
    <span class="external-id-value" [ngClass]="{ editable: !disabled }">
      {{ 'CUSTOM_FIELDS.EXTERNAL_ID.LABEL' | translate }}
      <mat-icon
        [glxyTooltip]="'CUSTOM_FIELDS.EXTERNAL_ID.EXTERNAL_IDENTIFIER_DESCRIPTION' | translate"
        [tooltipPositions]="[PopoverPositions.Bottom]"
      >
        info_outline
      </mat-icon>
      : {{ externalIdNewValue.value }}
    </span>
    <a *ngIf="!disabled" [glxyPopover]="externalIdPopover" (click)="showExternalIdPopover()">
      {{ (isNewFieldEditor() ? 'CUSTOM_FIELDS.EXTERNAL_ID.SET_IDENTIFIER' : 'ACTIONS.EDIT') | translate }}
    </a>
  </div>
  <div class="external-id" *ngIf="(isDuplicateExternalId$ | async) && !isExternalIdPopoverVisible">
    <mat-error>
      {{ 'CUSTOM_FIELDS.EXTERNAL_ID.IDENTIFIER_DUPLICATE_MESSAGE' | translate }}
    </mat-error>
  </div>
  <glxy-popover
    #externalIdPopover
    [maxWidth]="'320px'"
    [maxHeight]="'auto'"
    [isOpen]="isExternalIdPopoverVisible"
    [hasBackdrop]="false"
    [showBackdrop]="false"
    [hasArrow]="true"
    [keepOnScreen]="false"
    [padding]="'large'"
    [positions]="[PopoverPositions.BottomRight]"
  >
    <div class="text-bottom-spacing">
      {{ 'CUSTOM_FIELDS.EXTERNAL_ID.EXTERNAL_IDENTIFIER_DESCRIPTION' | translate }}
    </div>
    <glxy-form-field class="new-external-id">
      <input type="text" matInput [formControl]="externalIdNewValue" />
      <glxy-error *ngIf="externalIdNewValue.hasError('pattern')">
        {{ 'CUSTOM_FIELDS.EXTERNAL_ID.IDENTIFIER_VALIDATION_MESSAGE' | translate }}
      </glxy-error>
      <glxy-error *ngIf="externalIdNewValue.hasError('duplicate')">
        {{ 'CUSTOM_FIELDS.EXTERNAL_ID.IDENTIFIER_DUPLICATE_MESSAGE' | translate }}
      </glxy-error>
    </glxy-form-field>
    <glxy-popover-actions>
      <button mat-flat-button color="primary" (click)="setExternalId()">
        {{ 'ACTIONS.SAVE' | translate }}
      </button>
      <button mat-stroked-button (click)="cancelExternalId()">
        {{ 'ACTIONS.CANCEL' | translate }}
      </button>
    </glxy-popover-actions>
  </glxy-popover>
</ng-container>
